import { createFileRoute } from '@tanstack/react-router';
import DetailReportRpm from '@/featured/dashboard/report/detail-report-rpm';
import ReportNavTabs from '@/featured/dashboard/report/ReportNavTabs';

export default function ReportRpm() {
  return (
    <div className="w-full">
      <ReportNavTabs />
      <DetailReportRpm />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/report/rpm')({
  component: ReportRpm,
});
